export const API_URL = process.env.REACT_APP_API_URL;
export const APPLICATION_ID = process.env.REACT_APP_APPLICATION_ID;
export const SQUARE_LOCATION_ID = process.env.REACT_APP_SQUARE_LOCATION_ID;
export const ACTIVITY_URL = process.env.REACT_APP_ACTIVITY_URL;
